import { motion } from 'framer-motion'

interface BadgeProps {
  variant: 'novo' | 'quente' | 'limited' | 'em-breve'
  label?: string
}

const variantStyles = {
  novo: 'bg-emerald-500/20 text-emerald-400 border-emerald-500/30',
  quente: 'bg-orange-500/20 text-orange-400 border-orange-500/30',
  limited: 'bg-fuchsia-500/20 text-fuchsia-400 border-fuchsia-500/30',
  'em-breve': 'bg-zinc-600/20 text-zinc-400 border-zinc-500/30',
}

const variantLabels = {
  novo: 'NOVO',
  quente: 'QUENTE',
  limited: 'LIMITADO',
  'em-breve': 'EM BREVE',
}

export function Badge({ variant, label }: BadgeProps) {
  return (
    <motion.span
      initial={{ scale: 0, opacity: 0 }}
      animate={{ scale: 1, opacity: 1 }}
      transition={{ delay: 0.3, ease: [0.68, -0.55, 0.265, 1.55] }}
      className={`
        inline-flex items-center gap-1 px-2.5 py-1 rounded-full
        text-xs font-bold uppercase tracking-wider border
        ${variantStyles[variant]}
        ${label ? '' : 'min-w-[3.5rem] justify-center'}
      `}
    >
      <motion.span
        animate={{ opacity: [1, 0.6, 1] }}
        transition={{ duration: 1.5, repeat: Infinity, ease: 'easeInOut' }}
        className="relative top-[1px]"
      >
        {variant === 'novo' && '✨'}
        {variant === 'quente' && '🔥'}
        {variant === 'limited' && '💎'}
        {variant === 'em-breve' && '⏳'}
      </motion.span>
      {label || variantLabels[variant]}
    </motion.span>
  )
}